// services/scannerApi.js

import http, { API_BASE } from './http';

// ─── Helpers ──────────────────────────────────────────────────────────────────

function parseTradeInfo(raw) {
  if (raw == null) return {};
  if (typeof raw === 'object') return raw;
  if (typeof raw === 'string') {
    try { return JSON.parse(raw); } catch { return {}; }
  }
  return {};
}


// ─── Scanner Profiles ─────────────────────────────────────────────────────────

const scannerProfiles = {

  async list() {
    const { data } = await http.get(`${API_BASE}/api/trading_bots`, {
      params: { status: 'scanner_profile' },
    });
    return data || [];
  },

  async get(id) {
    const { data } = await http.get(`${API_BASE}/api/trading_bots/${id}`);
    return data;
  },

  async create(payload) {
    const { data } = await http.post(`${API_BASE}/api/trading_bots`, payload);
    return data;
  },

  async update(id, payload) {
    const { data } = await http.put(`${API_BASE}/api/trading_bots/${id}`, payload);
    return data;
  },

  async toggle(id) {
    const { data } = await http.post(`${API_BASE}/api/trading_bots/${id}/toggle_scanner`, null);
    return data;
  },

  async remove(id) {
    const { data } = await http.delete(`${API_BASE}/api/trading_bots/${id}`);
    return data;
  },

  async spawned(profileId, limit = 50) {
    const { data } = await http.get(`${API_BASE}/api/trading_bots`, {
      params: { spawned_from: profileId, limit },
    });
    return data || [];
  },
};


// ─── Universe ─────────────────────────────────────────────────────────────────

const universe = {
  /**
   * Preview which symbols a universe filter resolves to.
   * Used by the scanner form's live preview.
   *
   * @param {Object} filter - {
   *   type: 'top_volume' | 'list' | 'category',
   *   exchange?: string,         // 'binance.com' (defaults server-side)
   *   exchange_id?: number,      // alternative to exchange name
   *   market_type?: 'spot',
   *   limit?: number,
   *   quote?: string,            // 'USDT'
   *   min_volume?: number,
   *   symbols?: string[],
   *   category?: string,
   *   fee_filter?: 'any' | 'zero_maker' | 'zero_taker' | 'zero_either' | 'zero_both',
   *   blacklist?: string[],
   * }
   * @returns {Promise<{count: number, symbols: Array<{symbol, base_asset, quote_asset, ...}>}>}
   */
  async preview(filter) {
    const { data } = await http.post(`${API_BASE}/api/scanner/universe/preview`, filter);
    return data;
  },
};


export default { scannerProfiles, universe };
